var _ellipse, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUbicationWhere(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 42,
    viewBox: "0 0 33 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.82,
    cx: 16.0957,
    cy: 38.8686,
    rx: 11.8965,
    ry: 2.44928,
    fill: "#898989"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6253 16.1253C31.6253 18.1928 30.6826 20.5739 29.1926 23.0262C27.71 25.466 25.7246 27.9134 23.7258 30.099C21.7289 32.2824 19.7303 34.192 18.2299 35.5563C17.48 36.2382 16.8555 36.783 16.4191 37.1569C16.2956 37.2627 16.1872 37.3548 16.0952 37.4325C16.0033 37.3548 15.8949 37.2627 15.7714 37.1569C15.3349 36.783 14.7105 36.2382 13.9606 35.5563C12.4602 34.192 10.4615 32.2824 8.46471 30.099C6.46587 27.9134 4.48048 25.466 2.99791 23.0262C1.50783 20.5739 0.565217 18.1928 0.565217 16.1253C0.565217 7.54827 7.51824 0.595247 16.0952 0.595247C24.6722 0.595247 31.6253 7.54827 31.6253 16.1253Z",
    fill: "#47FFBD",
    stroke: "#53535D",
    strokeWidth: 1.13043
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.095,
    cy: 15.4256,
    r: 6.29814,
    fill: "#53535D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbicationWhere);
export default __webpack_public_path__ + "static/media/ubicationWhere.9967ef16f34902917c5830e1b10c2ca6.svg";
export { ForwardRef as ReactComponent };